import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  loginService,
  loginSwitchService,
} from "../../Services/ApiCalling/Auth";
import { getUserDetails } from "../../Services/ApiCalling/User";
import { decryptData } from "../../commons/Decode";

export const login = createAsyncThunk("auth/login", async (payload) => {
  try {
    return { user: payload };
  } catch (err) {}
});

export const switchLogin = createAsyncThunk(
  "auth/switch",
  async ({ payload }) => {
    try {
      return { user: payload };
    } catch (err) {}
  }
);

export const userDetails = createAsyncThunk(
  "auth/details",
  async ({ token, type }) => {
    try {
      let data = await getUserDetails(token, type);
      return { user: data };
    } catch (err) {}
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  try {
    localStorage.removeItem("OTC_V2_TOKEN");
    return null;
  } catch (err) {}
});

const authSlice = createSlice({
  name: "auth",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {})
      .addCase(login.fulfilled, (state, action) => {
        state.roles = action.payload?.user?.authorizedRoles;
        state.company = action.payload?.user?.company;
        state.consumer = action.payload?.user?.consumers;
        state.generator = action.payload?.user?.generators;
        state.discom = action.payload?.user?.discoms;
        state.token = action.payload?.user?.token;
        state.user = action.payload?.user;
        state.userType = action.payload?.user?.activeRole;
        state.isVerified = action.payload?.user?.isVerified;
      })
      .addCase(login.rejected, (state, action) => {});
    builder
      .addCase(logout.pending, (state) => {})
      .addCase(logout.fulfilled, (state, action) => {
        state = {};
      })
      .addCase(logout.rejected, (state, action) => {});
    builder
      .addCase(userDetails.pending, (state) => {})
      .addCase(userDetails.fulfilled, (state, action) => {
        state.userDetails = action?.payload?.user?.data?.data;
      })
      .addCase(userDetails.rejected, (state, action) => {});
    builder
      .addCase(switchLogin.pending, (state) => {})
      .addCase(switchLogin.fulfilled, (state, action) => {
        state.roles = action.payload?.user?.authorizedRoles;
        state.company = action.payload?.user?.company;
        state.consumer = action.payload?.user?.consumers;
        state.generator = action.payload?.user?.generators;
        state.discom = action.payload?.user?.discoms;
        state.token = action.payload?.user?.token;
        state.user = action.payload?.user;
        state.userType = action.payload?.user?.activeRole;
        state.isVerified = action.payload?.user?.isVerified;
      })
      .addCase(switchLogin.rejected, (state, action) => {});
  },
});

export default authSlice.reducer;
